import React from 'react'
import { Award, Eye, CheckCircle} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CardServicio = ({
  servicio
}) => {
  const navigate = useNavigate();

  const handleVerServicio = (servicio) => {
    // Navegar a detalles de solicitud
    navigate(`/contabilidad/detalles_servicio/${servicio.nombreEmpresa}/${servicio.codigo}`);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow mb-3">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
            <CheckCircle className="w-4 h-4 text-green-600" />
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 text-sm">{servicio.codigo}</h4>
            <p className="text-xs text-gray-600">{servicio.materia}</p>
            <p className="text-xs text-gray-600">{servicio.nombreEmpresa}</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm font-bold text-green-600">${servicio.preciocobrado?.toLocaleString()}</p>
          <p className="text-xs text-gray-500">Cobrado</p>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-2 mb-3 text-xs">
        <div>
          <p className="text-gray-500">Tutor</p>
          <p className="font-medium text-gray-700">{servicio.tutor || 'Sin asignar'}</p>
        </div>
        <div>
          <p className="text-gray-500">Fecha entrega</p>
          <p className="font-medium text-gray-700">
            {new Date(servicio.fechaentrega).toLocaleDateString()}
          </p>
        </div>
      </div>
      
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {servicio.getTrabajoEntregado() ? (
            <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs font-medium">
              Completado
            </span>
          ) : (
            <span className="bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full text-xs font-medium">
              En proceso
            </span>
          )}
          {servicio.servicioVerificado && (
            <Award className="w-3 h-3 text-blue-600" />
          )}
        </div>
        <div className="text-right">
          <p className="text-xs text-gray-500">Ganancia</p>
          <p className="text-xs font-medium text-blue-600">
            ${(servicio.preciocobrado - servicio.preciotutor || 0).toLocaleString()}
          </p>
        </div>
        <button
         onClick={() => 
            handleVerServicio(servicio)
          }
          className="flex-1 bg-blue-600 text-white px-3 py-2 rounded-md hover:bg-blue-700 transition-colors flex items-center justify-center gap-1 text-xs font-medium"
        >
          <Eye size={12} />
            Ver Servicios
          </button>
      </div>
    </div>
  )
}

export default CardServicio
